/**
 * O botão "Denunciar" da ficha do foco: abre a página da denúncia numa aba
 * nova, com o foco no endereço e os focos vizinhos (do que o mapa tem
 * carregado) num bilhete gravado no clique.
 */
import { Megaphone } from 'lucide-react';
import { useFireStore } from '../fires/store';
import type { EstimatedMunicipio } from '../fires/municipio';
import type { Fire } from '../fires/types';
import { focosVizinhos, gravarBilhete, janelaDoConjunto, urlDaDenuncia } from './pedido';

/** O foco com o município estimado no lugar do que o INPE não informou. */
function comMunicipio(fire: Fire, est: EstimatedMunicipio | null | 'pending'): { fire: Fire; municipioEstimado: boolean } {
  if (fire.municipio || !est || est === 'pending') return { fire, municipioEstimado: false };
  return { fire: { ...fire, municipio: est.nome, estado: fire.estado ?? est.uf, cdMun: fire.cdMun ?? est.cdMun }, municipioEstimado: true };
}

export function BotaoDenunciar(props: { fire: Fire; estimado: EstimatedMunicipio | null | 'pending' }) {
  const { fire, municipioEstimado } = comMunicipio(props.fire, props.estimado);
  const href = urlDaDenuncia(fire, { municipioEstimado });
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener"
      data-testid="botao-denunciar"
      title="Reúne as evidências deste foco e mostra onde denunciar"
      className="mt-2 flex min-h-8 w-full items-center justify-center gap-1.5 rounded-lg border border-fogo-500/50 bg-fogo-500/10 px-2 text-[12px] font-medium text-fogo-400 hover:bg-fogo-500/20 hover:text-white"
      onClick={(e) => {
        // O bilhete é gravado só no clique (a ficha não percorre os focos à toa); o endereço muda antes da navegação.
        const ds = useFireStore.getState().dataset;
        const bilhete = gravarBilhete({ janela: janelaDoConjunto(ds), vizinhos: focosVizinhos(ds, fire) });
        if (bilhete) e.currentTarget.href = urlDaDenuncia(fire, { municipioEstimado, bilhete });
      }}
    >
      <Megaphone className="size-3.5" aria-hidden />
      Denunciar
    </a>
  );
}
